import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    // Show splash for 2.5 seconds, then trigger fade out
    const timer = setTimeout(() => {
      setIsFadingOut(true);
      // Wait for fade-out CSS animation (0.5s) to finish before unmounting
      setTimeout(() => {
        onComplete();
      }, 500); 
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={`splash-screen ${isFadingOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <div className="splash-logo-container">
          {/* Animated Outer Rings */}
          <div className="ring ring-purple"></div>
          <div className="ring ring-cyan"></div>
          
          {/* Central Logo */}
          <div className="splash-logo">
            <img src="/logo.png" alt="Cabptoid Logo" />
          </div>
        </div>

        <div className="splash-loading-bar"></div>
      </div>
    </div>
  );
};

export default SplashScreen;
